// extracted by mini-css-extract-plugin
export default {"button":"FiltersButton_button__01-vR","buttonSmallIcon":"FiltersButton_buttonSmallIcon__7iYq+","buttonWithLabel":"FiltersButton_buttonWithLabel__JNFig"};